
import {STOCK_LIST} from "../../../Config/ApiUrl-CP";
import DatatableHelperMixin from "../../../../common/Mixin/Global/DatatableHelperMixin";
import {urlGenerator} from "../../../../common/Helper/AxiosHelper";
import SelectableStatusMixin from "../../../Helper/SelectableOptions/SelectableStatusMixin";
import {mapActions, mapGetters} from "vuex";
import {numberWithCurrencySymbol} from "../../../Helper/Helper";

export default {
    mixins: [DatatableHelperMixin, SelectableStatusMixin],
    data() {
        return {
            // noBranchSelected: false,
            options: {
                name: this.$t('stock'),
                url: null,
                showCount: true,
                showClearFilter: true,
                showHeader: true,
                columns: [
                    {
                        title: this.$t('products'),
                        type: 'component',
                        key: 'name',
                        componentName: 'app-stock-item-name',
                    },
                    {
                        title: this.$t('Category'),
                        type: 'custom-html',
                        key: 'product',
                        modifier: (value) => {
                            const mainCategoryArr = {
                                1: 'Raw Material',
                                2: 'Ready to use',
                                3: 'Custom Products',
                                4: 'Service',
                            };
                            return `<span>${mainCategoryArr[value?.main_category] ?? '-'}</span>`;
                        },
                    },
                    {
                        title: this.$t('Sub-category'),
                        type: 'custom-html',
                        key: 'product',
                        modifier: value => `<p class="mb-0">${value?.category?.name ?? '-'}</p>`,
                    },
                    {
                        title: this.$t('Sub-sub-category'),
                        type: 'custom-html',
                        key: 'product',
                        modifier: value => `<p class="mb-0">${value?.sub_category?.name ?? '-'}</p>`,
                    },
                    {
                        title: this.$t('Unit'),
                        type: 'custom-html',
                        key: 'product',
                        modifier: value => `<p class="mb-0">${value?.unit?.name ?? '-'}</p>`,
                    },
                    {
                        title: this.$t('Stock'),
                        type: 'custom-html',
                        key: 'stock_qty',
                        modifier: (value) => {
                            const qty = value ?? 0;
                            const cls = qty <= 0 ? 'text-danger font-weight-bold' : '';
                            return `<p class="mb-0 ${cls}">${qty}</p>`;
                        },
                    },
                ],
                actionType: "dropdown",
                actions: [],
                filters: [
                    {
                        title: this.$t('Category'),
                        type: 'drop-down-filter',
                        key: 'main_category',
                        option: [
                            { id: 1, value: this.$t('Raw Material') },
                            { id: 2, value: this.$t('Ready to use') },
                            { id: 3, value: this.$t('Custom Products') },
                            { id: 4, value: this.$t('Service') },
                        ],
                    },
                    {
                        title: this.$t('Sub-category'),
                        type: 'search-and-select-filter',
                        key: 'category_id',
                        settings: {
                            url: urlGenerator('app/selectable-categories'),
                            modifire: ({id, name}) => ({id, name}),
                            params: {},
                            per_page: 10,
                            queryName: 'search_by_name',
                            loader: 'app-pre-loader'
                        },
                        listValueField: 'name'
                    },
                    {
                        title: this.$t('Sub-sub-category'),
                        type: 'search-and-select-filter',
                        key: 'sub_category_id',
                        settings: {
                            url: urlGenerator('app/selectable-sub-categories'),
                            modifire: ({id, name}) => ({id, name}),
                            params: {},
                            per_page: 10,
                            queryName: 'search_by_name',
                            loader: 'app-pre-loader'
                        },
                        listValueField: 'name'
                    },
                    {
                        title: this.$t('Stock location'),
                        type: 'search-and-select-filter',
                        key: 'stock_location_id',
                        settings: {
                            url: urlGenerator('app/selectable-branches-or-warehouses'),
                            modifire: ({id, name}) => ({id, name}),
                            params: {},
                            per_page: 10,
                            queryName: 'search_by_name',
                            loader: 'app-pre-loader'
                        },
                        listValueField: 'name'
                    },
                    {
                        title: this.$t('Qty'),
                        type: 'drop-down-filter',
                        key: 'qty',
                        option: [
                            { id: '', value: this.$t('All') },
                            { id: 'zero', value: this.$t('0 (Out of stock)') },
                            { id: 'low', value: this.$t('Low (at/below reorder level)') },
                        ],
                    },
                ],
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                showAction: true,
                orderBy: 'desc',
                search: true,
            },
        }
    },

    methods: {
        ...mapActions(['setStocksByBranchOrWarehouseId']),
    },
    computed:{
        ...mapGetters(['getBranchOrWarehouseId', 'getBranchOrWarehouseName', 'getStocksByBranchOrWarehouse']),
    },
    mounted(){
        this.updateUrl(STOCK_LIST);
    },
    watch: {
        getBranchOrWarehouseId: {
            immediate: false,
            handler() {
                this.updateUrl(STOCK_LIST);
            }
        }
    },
}
